import React from 'react';
import axios from "../../containers/api";
import {Separator} from "../common/CustomBootstrap";
import {CustomInput} from "reactstrap";
import {toCurrency} from "../../helpers/Utils";
import {Table} from "../table/Table";

class PersonAccountActivities extends React.Component {
    state = {
        Id: this.props && this.props.id,
        role: this.props && this.props.role,
        AllAccountActivity: [],
         
        lastAccountActivity: [],
        //role: JSON.parse(localStorage.getItem("member")).role
        
    };

    componentDidMount() {
        this.GetAllAccountActivity();
        this.LastAccountActivity();
    }

    GetAllAccountActivity = () => {
        const model = {
            DriverId: this.state.role === "Driver" ? this.state.Id : null,
            TransportationCompanyId: this.state.role === "TransportationCompany" ? this.state.Id : null,
             
        }

        this.props.showSpinner();
        axios.post('api/v1/AccountActivity/TransactionsList', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data != null) {
                    this.setState({AllAccountActivity: res.data.data});
                } else {
                    this.setState({AllAccountActivity: []});
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };
    LastAccountActivity = () => {
        const model = {
            DriverId: this.state.role === "Driver" ? this.state.Id : null,
            TransportationCompanyId: this.state.role === "TransportationCompanyId" ? this.state.Id : null 
        }

        this.props.showSpinner();
        axios.post('api/v1/AccountActivity/TransactionsList', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data != null) {
                    this.setState({lastAccountActivity: res.data.data});
                } else {
                    this.setState({lastAccountActivity: []});
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };

    render() {
        return (
            <>
                <div>
                     

                    {/*<Table*/}
                    {/*    tableHeaders={[*/}
                    {/*        "موجودی",*/}
                    {/*        "قابل برداشت"*/}
                    {/*    ]}*/}

                    {/*    tableRow={this.state.lastAccountActivity}*/}

                    {/*    tableData={[*/}
                    {/*        x => {*/}
                    {/*            return x.totalBalance*/}
                    {/*        },*/}
                    {/*        x => {*/}
                    {/*            return x.availableBalance*/}
                    {/*        }*/}
                    {/*    ]}*/}
                    {/*/>*/}

                   {/* <Separator className="my-5" />*/}

                    <Table
                        tableHeaders={[
                            "شماره تراکنش",
                            "ساعت",
                            "تاریخ",
                            "نوع تراکنش (واریز/برداشت)",
                            "مبلغ",
                            "مبلغ مسدودی",
                            " مبلغ رفع مسدودی",
                            "موجودی",
                            "جمع مسدودی",
                            "قابل برداشت",
                            "توضیحات",
                            /*"انجام‌دهنده عملیات"*/
                        ]}

                        tableRow={this.state.AllAccountActivity}

                        tableData={[
                            x => {
                                return x.transactionNumber
                            },
                            x => {
                                return x.transactionTime
                            },x => {
                                return x.transactionDate
                            },
                            x => {
                                return x.accountType
                            },
                            x => {
                                return x.deposit !== 0 ? toCurrency(x.deposit) : toCurrency(x.withdraw)
                            },
                            x => {
                                return toCurrency(x.block)
                            },
                            x => {
                                return toCurrency(x.unBlock)
                            },
                            x => {
                                return toCurrency(x.totalBalance)
                            },
                            x => {
                                return toCurrency(x.totalBlock)
                            },
                            x => {
                                return toCurrency(x.availableBalance)
                            },
                            x => {
                                return x.description
                            },
                            //item => {
                            //    return item.fullname;
                            //}
                        ]}
                    />
                </div>
            </>
        )
    }
}

export default PersonAccountActivities;